import PageHeading from 'components/heading';
import Graph from './graph';
import Cards from './summaryCards';
import DateRangeBar from 'components/date-range-bar';
import useDateRange from 'utils/hooks/useDateRange';

const Dashboard = (): JSX.Element => {
  const {
    dateFrom,
    dateTo,
    setDateFrom,
    setDateTo,
    comparisonFrom,
    comparisonTo,
    dateFromISO,
    dateToISO,
  } = useDateRange({
    syncToUrl: true,
    defaultRange: 'today',
  });

  return (
    <div className="rounded-lg">
      <PageHeading
        heading="Analytics"
        className="mb-5"
        overrideContainerClass
      />
      <DateRangeBar
        dateFrom={dateFrom}
        dateTo={dateTo}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        comparisonFrom={comparisonFrom}
        comparisonTo={comparisonTo}
        className="mb-5"
      />
      <hr className="my-6 -mx-8 border-t border-gray-blue-10" />
      <Cards
        currentDates={{
          from: dateFromISO,
          to: dateToISO,
        }}
        prevDates={{ from: comparisonFrom, to: comparisonTo }}
      />
      <Graph
        currentDates={[dateFromISO, dateToISO]}
        prevDates={[comparisonFrom, comparisonTo]}
      />
    </div>
  );
};

export default Dashboard;
